import { render, staticRenderFns } from "./Person.view.vue?vue&type=template&id=7176e035"
import script from "./Person.view.vue?vue&type=script&lang=js"
export * from "./Person.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports